import React from "react";
import "./../Components/QuestionCard/QuestionCard.scss";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { MdOutlineInsertLink } from "react-icons/md";
import { Button, ButtonType } from "../Components";

export interface QuestionCardProps {
  questionNumber: string;
  url?: string;
  className?: string;
  hide?: boolean;
}

export const QuestionCard: React.FC<QuestionCardProps> = ({
  questionNumber,
  children,
  url = window.location.href.split("#")[0],
  className,
  hide = false,
}) => {
  return (
    <div
      id={questionNumber}
      className={`questionCard ${className ? className : ""} ${hide ? "hide" : ""}`}
    >
      <div className="questionHeader">
        <div className="questionNumber">{questionNumber}</div>
        <OverlayTrigger overlay={<Tooltip id={`${questionNumber}-copyButton`}>Copy</Tooltip>}>
          <Button
            id={`${questionNumber}-copyButton`}
            type={ButtonType.EMPTY}
            className="onboardingButton"
            onClick={() => navigator.clipboard.writeText(`${url}#${questionNumber}`)}
            icon={<MdOutlineInsertLink />}
          />
        </OverlayTrigger>
      </div>
      <div className="questionCardContent">{children}</div>
    </div>
  );
};
